/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { Box, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { SwitchAccountUserRoles } from './SwitchAccountUserRoles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0,
    marginBottom: theme.spacing(1),
  },
  chip: {
    marginRight: theme.spacing(0.5),
  },
  cardBody: {
    marginTop: theme.spacing(8),
    padding: '.7rem',
  },
  chipRoleType: {
    '&::before': {
      content: '',
      fontWeight: 'normal',
    },
    '&Admin': {
      backgroundColor: theme.palette.black,
      color: theme.palette.white,
    },
    '&Drafter': {
      backgroundColor: theme.palette.statusChip.DRAFT.main,
      color: theme.palette.statusChip.DRAFT.contrastText,
    },
    '&Signer': {
      backgroundColor: theme.palette.statusChip.READY_TO_SIGN.main,
      color: theme.palette.statusChip.READY_TO_SIGN.contrastText,
    },
    '&Sender': {
      backgroundColor: theme.palette.statusChip.READY_TO_SEND.main,
      color: theme.palette.statusChip.READY_TO_SEND.contrastText,
    },
    '&Payer': {
      backgroundColor: theme.palette.statusChip.PAYER.main,
      color: theme.palette.white,
    },
    '&default': {
      backgroundColor: theme.palette.statusChip.default.main,
      color: theme.palette.statusChip.default.contrastText,
    },
  },
}));

export function SwitchAccountCardBody({ type, roles = [] }) {
  const classes = useStyles();

  return (
    <Box className={classes.cardBody}>
      <Typography variant="h3" component="h3">
        {type}
      </Typography>
      <SwitchAccountUserRoles className={classes.root} roles={roles} />
    </Box>
  );
}
